/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Col, Container, Row, Table, Card } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import BreadCrumb from '../../components/Label/Breadcrumb'
import { BadgeStatusCOA } from '../../components/atoms/StatusLabel'
import api from '../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import Loading from '../../components/atoms/Loading'
import {
  capitalizeFirstLetter,
  convertDateWithTime
} from '../../helpers/constants'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '18px',
  fontWeight: '600'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#888',
  textTransform: 'uppercase',
  marginBottom: '0.2rem',
  letterSpacing: '0.5px'
}

const valueStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333'
}

function StockOpnameCycleCountSlotDetail() {
  const { state } = useLocation()
  const { id, slotId } = useParams()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [data, setData] = useState(null)

  const columnItems = [
    { key: 'sequence', label: 'No' },
    {
      key: 'item',
      label: 'Item Code - Name',
      component: (data) => `${data?.item_code || '-'} - ${data?.item || '-'}`
    },
    {
      key: 'batch',
      label: 'Batch',
      className: 'text-start',
      component: (value) => value?.batch || '-'
    },
    {
      key: 'total_pack',
      label: 'Qty System',
      component: (value) => value?.total_pack
    },
    {
      key: 'total_pack_good_checker',
      label: 'Checker Good Qty',
      component: (value) => value?.total_pack_good_checker
    },
    {
      key: 'total_pack_damaged_checker',
      label: 'Checker Not Good Qty',
      component: (value) => value?.total_pack_damaged_checker
    },
    {
      key: 'total_pack_good_pic',
      label: 'PIC Good Qty',
      component: (value) => value?.total_pack_good_pic
    },
    {
      key: 'total_pack_damaged_pic',
      label: 'PIC Not Good Qty',
      component: (value) => value?.total_pack_damaged_pic
    }
  ]
  const columnHistories = [
    { key: 'sequence', label: 'No' },
    {
      key: 'date',
      label: 'Date',
      component: (value) =>
        value?.date ? convertDateWithTime(value?.date, 'DD/MM/YYYY') : '-'
    },
    {
      key: 'item_name',
      label: 'Item Code - Name',
      component: (data) =>
        `${data?.item_code || '-'} - ${data?.item_name || '-'}`
    },
    {
      key: 'batch',
      label: 'Batch',
      className: 'text-end',
      component: (value) => value?.batch || '-'
    },
    {
      key: 'total_pack',
      label: 'Total Pack',
      className: 'text-end',
      component: (value) => value?.total_pack || '-'
    },
    {
      key: 'ticket_code',
      label: 'Ticket',
      className: 'text-end',
      component: (value) => (value?.ticket ? value?.ticket?.toUpperCase() : '-')
    }
  ]

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await api.get(`stock-opname/${id}/${slotId}`)
      const { data: dataResponse } = res.data
      setData(dataResponse)
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: { fontSize: '14px', fontWeight: '600' }
      })
      handleBack('detail')
    } finally {
      setLoading(false)
    }
  }

  const handleBack = (type = null) => {
    if (!type) {
      navigate('/stock-opname/cycle-count', {
        replace: true,
        state: state
      })
    }
    if (type === 'detail') {
      navigate(`/stock-opname/cycle-count/detail/${state?.id}`, {
        replace: true,
        state: state
      })
    }
  }

  useEffect(() => {
    fetchData()
  }, [id, slotId])

  if (loading) {
    return <Loading />
  }

  const renderInfoItem = (label, value) => (
    <div className="d-flex flex-column">
      <span style={labelStyle}>{label}</span>
      <span style={valueStyle}>{value || '-'}</span>
    </div>
  )

  return (
    <Container fluid className="px-4 mb-5">
      <Toaster />
      <Row className="mb-3">
        <Col md={12}>
          <BreadCrumb
            label={state?.code}
            link="/stock-opname/cycle-count"
            back="CYCLE COUNT"
            labelSub="OPNAME DETAIL"
            labelSubLink={`/stock-opname/cycle-count/detail/${state?.id}`}
            status={state?.status}
            type="BadgeStatusPrList"
            stateValue={state}
          />
        </Col>
      </Row>

      <Card style={cardStyle}>
        <Row>
          <Col md={3}>{renderInfoItem('SLOT', data?.slot)}</Col>
          <Col md={3}>{renderInfoItem('RACK NAME', data?.rack)}</Col>
          <Col md={2}>
            {renderInfoItem(
              'RACK TYPE',
              data?.rack_type ? capitalizeFirstLetter(data?.rack_type) : '-'
            )}
          </Col>
          <Col md={2}>{renderInfoItem('CHECKER', data?.checker)}</Col>
          <Col md={2}>{renderInfoItem('PIC', data?.pic)}</Col>
        </Row>
        <hr className="text-muted opacity-25 my-4" />
        <Row>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>CHECKER CHECK</span>
              <div
                className="mt-1"
                style={{ fontSize: '12px', width: 'fit-content' }}
              >
                {data?.checker_status && (
                  <BadgeStatusCOA text={data?.checker_status || 'match'} />
                )}
                {!data?.checker_status && '-'}
              </div>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>PIC CHECK</span>
              <div
                className="mt-1"
                style={{ fontSize: '12px', width: 'fit-content' }}
              >
                {data?.pic_status && (
                  <BadgeStatusCOA text={data?.pic_status || 'match'} />
                )}
                {!data?.pic_status && '-'}
              </div>
            </div>
          </Col>
        </Row>
      </Card>

      <Card style={cardStyle}>
        <Row className="mb-3">
          <Col md={12} className="d-flex align-items-center">
            <h5 style={headerTitleStyle} className="mb-0">
              Item List
            </h5>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Table responsive hover className="border-top mb-0">
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  {columnItems.map((column) => (
                    <th
                      className={`align-middle p-2 ${column.className ?? ''}`}
                      key={column.key}
                      style={tableHeaderStyle}
                    >
                      <span>{column.label}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!data?.items?.left_item?.length && (
                  <tr>
                    <td
                      colSpan={columnItems.length}
                      className="text-center p-5"
                    >
                      <div className="text-muted">Data empty</div>
                    </td>
                  </tr>
                )}
                {data?.items?.left_item?.length > 0 &&
                  data?.items?.left_item?.map((item, index) => (
                    <tr key={`left-item-${index}`}>
                      {columnItems.map((column) => (
                        <td
                          key={column.key}
                          className={`align-middle p-2 ${
                            column.className ?? ''
                          }`}
                          style={{
                            borderBottom: '1px solid #f0f0f0',
                            fontSize: '0.9rem'
                          }}
                        >
                          {column.key === 'sequence' && index + 1}
                          {column.component && column.component(item)}
                          {!column.component && item[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>

      <Card style={cardStyle}>
        <Row className="mb-3">
          <Col md={12} className="d-flex align-items-center">
            <h5 style={headerTitleStyle} className="mb-0">
              Item History (
              {convertDateWithTime(
                data?.items?.item_histories?.start_date,
                'DD/MM/YYYY'
              )}{' '}
              -{' '}
              {convertDateWithTime(
                data?.items?.item_histories?.end_date,
                'DD/MM/YYYY'
              )}
              )
            </h5>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Table responsive hover className="border-top mb-0">
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  {columnHistories.map((column) => (
                    <th
                      className={`align-middle p-2 ${column.className ?? ''}`}
                      key={column.key}
                      style={tableHeaderStyle}
                    >
                      <span>{column.label}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!data?.items?.item_histories?.items?.length && (
                  <tr>
                    <td
                      colSpan={columnHistories.length}
                      className="text-center p-5"
                    >
                      <div className="text-muted">Data empty</div>
                    </td>
                  </tr>
                )}
                {data?.items?.item_histories?.items.length > 0 &&
                  data?.items?.item_histories?.items.map((item, index) => (
                    <tr key={`item-history-${index}`}>
                      {columnHistories.map((column) => (
                        <td
                          key={column.key}
                          className={`align-middle p-2 ${
                            column.className ?? ''
                          }`}
                          style={{
                            borderBottom: '1px solid #f0f0f0',
                            fontSize: '0.9rem'
                          }}
                        >
                          {column.key === 'sequence' && index + 1}
                          {column.component && column.component(item)}
                          {!column.component && item[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default StockOpnameCycleCountSlotDetail
